// extracted by mini-css-extract-plugin
module.exports = {"Column":"Column_Column__1DDeB"};